<template>
   <div>
      <v-alert v-if="errors" type="error" text dense dismissible class="mb-3" @input="errors = null">
         {{ errors }}
      </v-alert>

      <v-data-table
         :headers="headers"
         :items="listitems"
         :loading="loading"
         sort-by="no"
         class="border"
         dense
      >
         <template v-slot:top>
            <v-toolbar flat color="white">
               <v-toolbar-title>Elections</v-toolbar-title>
               <v-divider class="mx-4" inset vertical></v-divider>
               <v-spacer></v-spacer>
               <v-btn color="primary" dark class="mb-2" @click="additem">
                  <v-icon left small>mdi-plus</v-icon>
                  New Election
               </v-btn>
            </v-toolbar>
         </template>

         <template v-slot:[`item.datestart`]="{ item }">
            {{ formatDisplayDate(item.datestart) }}
         </template>
         <template v-slot:[`item.dateend`]="{ item }">
            {{ formatDisplayDate(item.dateend) }}
         </template>
         <template v-slot:[`item.dateregstart`]="{ item }">
            {{ formatDisplayDate(item.dateregstart) }}
         </template>
         <template v-slot:[`item.dateregend`]="{ item }">
            {{ formatDisplayDate(item.dateregend) }}
         </template>
         <template v-slot:[`item.electstatus`]="{ item }">
            <v-chip small :color="statusColor(item.electstatus)" dark>
               {{ statusLabel(item.electstatus) }}
            </v-chip>
         </template>
         <template v-slot:[`item.actions`]="{ item }">
            <v-btn icon small color="success" title="View results" @click="openResults(item)">
               <v-icon small>mdi-trophy-outline</v-icon>
            </v-btn>
            <v-btn icon small color="primary" title="Manage election" @click="editItem(item)">
               <v-icon small>mdi-pencil</v-icon>
            </v-btn>
            <v-btn icon small color="red" title="Delete election" @click="deleteItem(item)">
               <v-icon small>mdi-delete</v-icon>
            </v-btn>
         </template>
      </v-data-table>

      <v-dialog v-model="dlgedit" max-width="1180" persistent scrollable>
         <v-card class="election-dialog">
            <v-toolbar flat color="primary" dark>
               <v-toolbar-title>
                  <v-icon left>mdi-ballot-outline</v-icon>
                  Edit Election
               </v-toolbar-title>
               <v-spacer></v-spacer>
               <v-btn icon @click="dlgedit = false">
                  <v-icon>mdi-close</v-icon>
               </v-btn>
            </v-toolbar>

            <v-card-text class="pa-0">
               <v-tabs v-model="tab" background-color="blue darken-3" dark dense>
                  <v-tab key="T1">
                     <v-icon left small>mdi-ballot-outline</v-icon>
                     Election Setup
                  </v-tab>
                  <v-tab key="T2" :disabled="!currentElectId">
                     <v-icon left small>mdi-format-list-numbered</v-icon>
                     Positions
                  </v-tab>
                  <v-tab key="T3" :disabled="!currentElectId">
                     <v-icon left small>mdi-account-group</v-icon>
                     Candidates
                  </v-tab>
               </v-tabs>

               <v-tabs-items v-model="tab">
                  <v-tab-item key="T1">
                     <div class="pa-4">
                        <election-form
                           :form.sync="formmodel"
                           :zones="zones"
                           :saving="saving"
                           submit-label="Update Election"
                           @submit="updateItem"
                           @cancel="dlgedit = false"
                        ></election-form>
                     </div>
                  </v-tab-item>
                  <v-tab-item key="T2">
                     <div class="pa-4">
                        <v-alert type="info" text dense>
                           Add positions first before adding candidates. Example: President, Vice President, Council Member.
                        </v-alert>
                        <table-election-positions :electid="currentElectId"></table-election-positions>
                     </div>
                  </v-tab-item>
                  <v-tab-item key="T3">
                     <div class="pa-4">
                        <v-alert type="info" text dense>
                           Candidates are linked to the positions created for this election.
                        </v-alert>
                        <table-election-candidates :electid="currentElectId"></table-election-candidates>
                     </div>
                  </v-tab-item>
               </v-tabs-items>
            </v-card-text>
         </v-card>
      </v-dialog>

      <v-dialog v-model="dlgadd" max-width="1180" persistent scrollable>
         <v-card class="election-dialog">
            <v-toolbar flat color="primary" dark>
               <v-toolbar-title>
                  <v-icon left>mdi-ballot-outline</v-icon>
                  New Election
               </v-toolbar-title>
               <v-spacer></v-spacer>
               <v-btn icon @click="dlgadd = false">
                  <v-icon>mdi-close</v-icon>
               </v-btn>
            </v-toolbar>

            <v-card-text class="pa-4 election-dialog-body">
               <v-alert type="info" text dense class="mb-4">
                  Complete the setup first. After saving, open the election to add positions and candidates.
               </v-alert>
               <election-form
                  :form.sync="formmodel"
                  :zones="zones"
                  :saving="saving"
                  submit-label="Create Election"
                  @submit="createItem"
                  @cancel="dlgadd = false"
               ></election-form>
            </v-card-text>
         </v-card>
      </v-dialog>

      <v-dialog v-model="dlgconfirm" width="460" persistent>
         <v-card>
            <v-card-title>Delete Election?</v-card-title>
            <v-card-text>
               This will remove the election from admin and member lists.
               <div class="mt-3 font-weight-bold">{{ todelete ? todelete.title : '' }}</div>
            </v-card-text>
            <v-card-actions class="px-4 pb-4">
               <v-spacer></v-spacer>
               <v-btn text @click="closeconfirm">Cancel</v-btn>
               <v-btn color="red darken-1" dark :loading="deleting" @click="dodelete(todelete)">
                  Delete
               </v-btn>
            </v-card-actions>
         </v-card>
      </v-dialog>

      <v-dialog v-model="resultDialog" max-width="1100" scrollable>
         <v-card>
            <v-toolbar flat color="success" dark>
               <v-toolbar-title>
                  <v-icon left>mdi-trophy-outline</v-icon>
                  {{ resultTitle }} - Results
               </v-toolbar-title>
               <v-spacer></v-spacer>
               <v-btn icon @click="resultDialog = false">
                  <v-icon>mdi-close</v-icon>
               </v-btn>
            </v-toolbar>
            <v-card-text class="pa-5">
               <v-progress-linear v-if="resultLoading" indeterminate color="success" class="mb-4"></v-progress-linear>
               <v-alert v-else-if="resultItems.length === 0" type="info" outlined>
                  No result data is available yet.
               </v-alert>
               <v-row v-else>
                  <v-col v-for="group in groupedResults" :key="group.category" cols="12">
                     <v-card outlined>
                        <v-card-title class="grey lighten-4">
                           {{ group.category }}
                           <v-spacer></v-spacer>
                           <v-chip color="success" dark small>{{ group.totalVotes }} votes</v-chip>
                        </v-card-title>
                        <v-data-table
                           :headers="resultHeaders"
                           :items="group.candidates"
                           hide-default-footer
                           dense
                        >
                           <template v-slot:[`item.cndphoto`]="{ item }">
                              <v-avatar size="46">
                                 <v-img v-if="candidatePhoto(item)" :src="candidatePhoto(item)"></v-img>
                                 <v-icon v-else color="grey lighten-1">mdi-account-circle</v-icon>
                              </v-avatar>
                           </template>
                           <template v-slot:[`item.cndname`]="{ item }">
                              <strong>{{ item.cndname }}</strong>
                              <v-chip v-if="item.isWinner" x-small color="amber darken-2" dark class="ml-2">
                                 Winner
                              </v-chip>
                           </template>
                           <template v-slot:[`item.totalvotes`]="{ item }">
                              <span class="font-weight-bold">{{ item.totalvotes || 0 }}</span>
                           </template>
                        </v-data-table>
                     </v-card>
                  </v-col>
               </v-row>
            </v-card-text>
            <v-card-actions>
               <v-spacer></v-spacer>
               <v-btn text @click="resultDialog = false">Close</v-btn>
            </v-card-actions>
         </v-card>
      </v-dialog>
   </div>
</template>

<script>
const axios = require('axios')
import TableElectionCandidates from './TableElectionCandidates.vue'
import TableElectionPositions from './TableElectionPositions.vue'

const ElectionForm = {
   name: 'ElectionForm',
   props: {
      form: { type: Object, required: true },
      zones: { type: Array, default: () => [] },
      saving: { type: Boolean, default: false },
      submitLabel: { type: String, default: 'Save Election' },
   },
   data: () => ({
      valid: false,
      menu: {},
      membertypeOptions: [
         { text: 'Student (STU)', value: 'STU' },
         { text: 'Graduate (GRA)', value: 'GRA' },
         { text: 'Corporate (COR)', value: 'COR' },
         { text: 'Fellow (FEL)', value: 'FEL' },
         { text: 'Associate (ASC)', value: 'ASC' },
      ],
      electionTypeOptions: [
         { text: 'Nation Wide', value: 'N' },
         { text: 'Branch / State', value: 'S' },
      ],
      statusOptions: [
         { text: 'Disabled - draft only', value: '00' },
         { text: 'Enabled - visible to members', value: '01' },
         { text: 'Suspended', value: '02' },
      ],
      resultVisibilityOptions: [
         { text: 'Admin only - hide from members', value: 'hidden' },
         { text: 'Show after voting ends', value: 'after_end' },
         { text: 'Show after member has voted', value: 'after_vote' },
         { text: 'Live/current results', value: 'live' },
      ],
      ageRuleOptions: [
         { text: 'No age restriction', value: '' },
         { text: 'Age must be greater/equal', value: '>' },
         { text: 'Age must be below', value: '<' },
      ],
      requiredRule: v => !!v || 'Required',
      requiredArrayRule: v => (Array.isArray(v) && v.length > 0) || 'Select at least one member type',
   }),
   computed: {
      localForm: {
         get() {
            return this.form
         },
         set(value) {
            this.$emit('update:form', value)
         },
      },
      selectedMemberTypes: {
         get() {
            return this.parseMemberTypes(this.localForm.electmembertypes)
         },
         set(value) {
            this.localForm.electmembertypes = JSON.stringify(value || [])
         },
      },
      timelineError() {
         const pairs = [
            ['datestart', 'dateend', 'Election end must be after election start.'],
            ['dateregstart', 'dateregend', 'Registration end must be after registration start.'],
            ['datevotestart', 'datevoteend', 'Voting end must be after voting start.'],
         ]

         for (let i = 0; i < pairs.length; i++) {
            const [startKey, endKey, message] = pairs[i]
            const start = this.toDate(this.localForm[startKey])
            const end = this.toDate(this.localForm[endKey])
            if (start && end && end < start) {
               return message
            }
         }
         return ''
      },
      canSave() {
         return this.valid && !this.timelineError && this.selectedMemberTypes.length > 0
      },
   },
   methods: {
      parseMemberTypes(value) {
         if (Array.isArray(value)) return value
         if (!value) return []
         try {
            const decoded = JSON.parse(value)
            return Array.isArray(decoded) ? decoded : []
         } catch (e) {
            return String(value).split(',').map(item => item.trim()).filter(Boolean)
         }
      },
      toDate(value) {
         if (!value) return null
         const date = new Date(value)
         return isNaN(date.getTime()) ? null : date
      },
      submit() {
         if (this.$refs.form && !this.$refs.form.validate()) return
         if (this.timelineError) return
         this.$emit('submit')
      },
   },
   template: `
      <v-form ref="form" v-model="valid" lazy-validation>
         <v-row>
            <v-col cols="12" lg="7">
               <v-card outlined class="election-form-section">
                  <div class="election-section-title">
                     <v-avatar color="blue lighten-5" size="34" class="mr-3">
                        <v-icon color="primary">mdi-file-document-edit-outline</v-icon>
                     </v-avatar>
                     <div>
                        <div class="subtitle-1 font-weight-bold">Basic Information</div>
                        <div class="caption grey--text text--darken-1">Name, description and rules shown to members.</div>
                     </div>
                  </div>

                  <v-row dense>
                     <v-col cols="12" md="8">
                        <v-text-field
                           v-model="localForm.title"
                           label="Election Title"
                           placeholder="Example: MIP Council Election 2026"
                           outlined
                           dense
                           :rules="[requiredRule]"
                        ></v-text-field>
                     </v-col>
                     <v-col cols="12" md="4">
                        <v-select
                           v-model="localForm.electstatus"
                           :items="statusOptions"
                           label="Status"
                           outlined
                           dense
                           :rules="[requiredRule]"
                        ></v-select>
                     </v-col>
                     <v-col cols="12">
                        <v-select
                           v-model="localForm.result_visibility"
                           :items="resultVisibilityOptions"
                           label="Member Result Visibility"
                           outlined
                           dense
                           hint="Admin can always view results. This controls when members can see vote results."
                           persistent-hint
                        ></v-select>
                     </v-col>
                     <v-col cols="12">
                        <v-textarea
                           v-model="localForm.description"
                           label="Description"
                           placeholder="Short explanation about this election"
                           outlined
                           dense
                           rows="3"
                           auto-grow
                           hide-details="auto"
                        ></v-textarea>
                     </v-col>
                     <v-col cols="12">
                        <v-textarea
                           v-model="localForm.electrules"
                           label="Rules / Instructions"
                           placeholder="Voting rules, eligibility notes, or instructions"
                           outlined
                           dense
                           rows="3"
                           auto-grow
                           hide-details="auto"
                        ></v-textarea>
                     </v-col>
                  </v-row>
               </v-card>
            </v-col>

            <v-col cols="12" lg="5">
               <v-card outlined class="election-form-section">
                  <div class="election-section-title">
                     <v-avatar color="green lighten-5" size="34" class="mr-3">
                        <v-icon color="green darken-2">mdi-account-filter-outline</v-icon>
                     </v-avatar>
                     <div>
                        <div class="subtitle-1 font-weight-bold">Eligibility</div>
                        <div class="caption grey--text text--darken-1">Control who can view/register/vote.</div>
                     </div>
                  </div>

                  <v-select
                     v-model="localForm.electtype"
                     :items="electionTypeOptions"
                     label="Election Type"
                     outlined
                     dense
                     :rules="[requiredRule]"
                  ></v-select>
                  <v-select
                     v-model="localForm.electzone"
                     :items="zones"
                     item-text="zonename"
                     item-value="id"
                     label="Zone"
                     outlined
                     dense
                     clearable
                     hint="Leave empty for all zones."
                     persistent-hint
                  ></v-select>
                  <v-select
                     v-model="selectedMemberTypes"
                     :items="membertypeOptions"
                     label="Eligible Member Types"
                     multiple
                     chips
                     small-chips
                     outlined
                     dense
                     :rules="[requiredArrayRule]"
                  ></v-select>
                  <v-row dense>
                     <v-col cols="12" md="7">
                        <v-select
                           v-model="localForm.agerestrule"
                           :items="ageRuleOptions"
                           label="Age Rule"
                           outlined
                           dense
                        ></v-select>
                     </v-col>
                     <v-col cols="12" md="5">
                        <v-text-field
                           v-model.number="localForm.agerest"
                           label="Age"
                           type="number"
                           min="0"
                           outlined
                           dense
                           :disabled="!localForm.agerestrule"
                        ></v-text-field>
                     </v-col>
                  </v-row>
               </v-card>
            </v-col>

            <v-col cols="12">
               <v-card outlined class="election-form-section">
                  <div class="election-section-title">
                     <v-avatar color="orange lighten-5" size="34" class="mr-3">
                        <v-icon color="orange darken-2">mdi-calendar-clock</v-icon>
                     </v-avatar>
                     <div>
                        <div class="subtitle-1 font-weight-bold">Timeline</div>
                        <div class="caption grey--text text--darken-1">Use date picker fields. End time must be after start time.</div>
                     </div>
                  </div>

                  <v-alert v-if="timelineError" type="error" text dense>{{ timelineError }}</v-alert>

                  <v-row dense>
                     <v-col cols="12" md="4">
                        <v-card flat class="timeline-card blue lighten-5">
                           <div class="font-weight-bold mb-3 blue--text text--darken-3">Election Period</div>
                           <v-text-field
                              v-model="localForm.datestart"
                              label="Election Start"
                              type="datetime-local"
                              outlined
                              dense
                              background-color="white"
                              :rules="[requiredRule]"
                           ></v-text-field>
                           <v-text-field
                              v-model="localForm.dateend"
                              label="Election End"
                              type="datetime-local"
                              outlined
                              dense
                              background-color="white"
                              :rules="[requiredRule]"
                           ></v-text-field>
                        </v-card>
                     </v-col>
                     <v-col cols="12" md="4">
                        <v-card flat class="timeline-card green lighten-5">
                           <div class="font-weight-bold mb-3 green--text text--darken-3">Registration Period</div>
                           <v-text-field
                              v-model="localForm.dateregstart"
                              label="Registration Start"
                              type="datetime-local"
                              outlined
                              dense
                              background-color="white"
                              :rules="[requiredRule]"
                           ></v-text-field>
                           <v-text-field
                              v-model="localForm.dateregend"
                              label="Registration End"
                              type="datetime-local"
                              outlined
                              dense
                              background-color="white"
                              :rules="[requiredRule]"
                           ></v-text-field>
                        </v-card>
                     </v-col>
                     <v-col cols="12" md="4">
                        <v-card flat class="timeline-card purple lighten-5">
                           <div class="font-weight-bold mb-3 purple--text text--darken-3">Voting Period</div>
                           <v-text-field
                              v-model="localForm.datevotestart"
                              label="Voting Start"
                              type="datetime-local"
                              outlined
                              dense
                              background-color="white"
                              :rules="[requiredRule]"
                           ></v-text-field>
                           <v-text-field
                              v-model="localForm.datevoteend"
                              label="Voting End"
                              type="datetime-local"
                              outlined
                              dense
                              background-color="white"
                              :rules="[requiredRule]"
                           ></v-text-field>
                        </v-card>
                     </v-col>
                  </v-row>
               </v-card>
            </v-col>
         </v-row>

         <v-card-actions class="election-form-actions">
            <v-spacer></v-spacer>
            <v-btn text @click="$emit('cancel')">Cancel</v-btn>
            <v-btn color="primary" :loading="saving" :disabled="!canSave" @click="submit">
               <v-icon left small>mdi-content-save</v-icon>
               {{ submitLabel }}
            </v-btn>
         </v-card-actions>
      </v-form>
   `,
}

export default {
   name: "TableElections",
   components: {
      ElectionForm,
      TableElectionCandidates,
      TableElectionPositions,
   },

   data: () => ({
      user: null,
      errors: null,
      loading: false,
      saving: false,
      deleting: false,
      headers: [
         { text: "No.", align: "start", sortable: true, width: "70", value: "no" },
         { text: "Election Title", sortable: false, value: "title" },
         { text: "Election Start", sortable: false, value: "datestart" },
         { text: "Election End", sortable: false, value: "dateend" },
         { text: "Registration Start", sortable: false, value: "dateregstart" },
         { text: "Registration End", sortable: false, value: "dateregend" },
         { text: "Status", sortable: false, value: "electstatus" },
         { text: "Actions", value: "actions", align: "end", sortable: false },
      ],
      tab: null,
      listitems: [],
      zones: [],
      dlgconfirm: false,
      dlgedit: false,
      dlgadd: false,
      todelete: null,
      formmodel: {},
      currentElectId: null,
      resultDialog: false,
      resultLoading: false,
      resultTitle: '',
      resultElectId: null,
      resultItems: [],
      resultHeaders: [
         { text: 'Photo', value: 'cndphoto', sortable: false, width: '80' },
         { text: 'Candidate', value: 'cndname', sortable: false },
         { text: 'Member ID', value: 'cndmemberid', sortable: false },
         { text: 'Votes', value: 'totalvotes', sortable: false, align: 'end', width: '120' },
      ],
   }),

   computed: {
      groupedResults() {
         const groups = {}
         this.resultItems.forEach(item => {
            const category = item.Category || 'Election Position'
            if (!groups[category]) groups[category] = []
            groups[category].push({
               ...item,
               totalvotes: parseInt(item.totalvotes || 0),
            })
         })

         return Object.keys(groups).map(category => {
            const candidates = groups[category].sort((a, b) => b.totalvotes - a.totalvotes || String(a.cndname).localeCompare(String(b.cndname)))
            const winningVotes = candidates.length ? candidates[0].totalvotes : 0
            return {
               category,
               totalVotes: candidates.reduce((sum, item) => sum + item.totalvotes, 0),
               candidates: candidates.map(item => ({
                  ...item,
                  isWinner: item.totalvotes === winningVotes && winningVotes > 0,
               })),
            }
         })
      },
   },

   mounted() {
      this.user = this.$page.user
      this.initialize()
      this.loadZones()
   },

   methods: {
      blankForm() {
         return {
            title: '',
            description: '',
            electrules: '',
            electtype: 'N',
            electstate: '',
            electzone: null,
            electmembertypes: JSON.stringify(['GRA', 'COR', 'FEL']),
            datestart: '',
            dateend: '',
            dateregstart: '',
            dateregend: '',
            datevotestart: '',
            datevoteend: '',
            electstatus: '00',
            result_visibility: 'after_end',
            agerest: null,
            agerestrule: '',
         }
      },

      initialize() {
         this.loading = true
         axios.get('/admin/agm/elections')
            .then(({ data }) => {
               this.listitems = data.status === 'OK' && Array.isArray(data.data)
                  ? data.data.map((item, idx) => ({ ...item, no: idx + 1 }))
                  : []
            })
            .catch(() => { this.errors = 'Unable to load elections.' })
            .finally(() => { this.loading = false })
      },

      loadZones() {
         axios.get('/admin/zone/ddlist')
            .then(({ data }) => {
               this.zones = data.status === 'OK' && Array.isArray(data.data) ? data.data : []
            })
            .catch(() => { this.zones = [] })
      },

      additem() {
         this.formmodel = this.blankForm()
         this.dlgadd = true
      },

      normalizePayload() {
         const payload = { ...this.formmodel }
         payload.electzone = payload.electzone ? Number(payload.electzone) : null
         payload.agerest = payload.agerestrule ? Number(payload.agerest || 0) : null
         payload.agerestrule = payload.agerestrule || null
         payload.result_visibility = payload.result_visibility || 'after_end'
         return payload
      },

      createItem() {
         this.saving = true
         axios.post('/admin/agm/election/add', this.normalizePayload())
            .then(({ data }) => {
               if (data.status !== 'OK') {
                  this.errors = data.error || 'Unable to create election.'
                  return
               }
               this.dlgadd = false
               this.initialize()
            })
            .catch((error) => { this.errors = this.errorMessage(error, 'Unable to create election.') })
            .finally(() => { this.saving = false })
      },

      editItem(pItem) {
         this.currentElectId = pItem.id
         this.formmodel = {
            ...this.blankForm(),
            ...pItem,
            datestart: this.toDatetimeLocal(pItem.datestart),
            dateend: this.toDatetimeLocal(pItem.dateend),
            dateregstart: this.toDatetimeLocal(pItem.dateregstart),
            dateregend: this.toDatetimeLocal(pItem.dateregend),
            datevotestart: this.toDatetimeLocal(pItem.datevotestart),
            datevoteend: this.toDatetimeLocal(pItem.datevoteend),
            agerestrule: pItem.agerestrule || '',
            result_visibility: pItem.result_visibility || 'after_end',
         }
         this.tab = 0
         this.dlgedit = true
      },

      updateItem() {
         this.saving = true
         const payload = { ...this.normalizePayload(), id: this.currentElectId }
         axios.post('/admin/agm/election/update', payload)
            .then(({ data }) => {
               if (data.status !== 'OK') {
                  this.errors = data.error || 'Unable to update election.'
                  return
               }
               this.dlgedit = false
               this.initialize()
            })
            .catch((error) => { this.errors = this.errorMessage(error, 'Unable to update election.') })
            .finally(() => { this.saving = false })
      },

      closeconfirm() {
         this.dlgconfirm = false
         this.todelete = null
      },

      deleteItem(pItem) {
         this.todelete = pItem
         this.dlgconfirm = true
      },

      dodelete(pItem) {
         if (!pItem) return
         this.deleting = true
         axios.post('/admin/agm/election/delete', { id: pItem.id })
            .then(({ data }) => {
               if (data.status !== 'OK') {
                  this.errors = data.error || 'Unable to delete election.'
                  return
               }
               this.closeconfirm()
               this.initialize()
            })
            .catch((error) => { this.errors = this.errorMessage(error, 'Unable to delete election.') })
            .finally(() => { this.deleting = false })
      },

      openResults(item) {
         this.resultTitle = item.title
         this.resultElectId = item.id
         this.resultDialog = true
         this.resultLoading = true
         this.resultItems = []
         axios.get('/admin/agm/electioncandidates/' + item.id)
            .then(({ data }) => {
               if (data.status === 'OK' && Array.isArray(data.data)) {
                  this.resultItems = data.data
                  return
               }
               this.errors = data.error || 'Unable to load election results.'
            })
            .catch((error) => { this.errors = this.errorMessage(error, 'Unable to load election results.') })
            .finally(() => { this.resultLoading = false })
      },

      candidatePhoto(candidate) {
         const value = candidate.photo_url || candidate.cndphoto || ''
         if (!value) return ''
         if (/^(https?:)?\/\//.test(value) || value.charAt(0) === '/') return value
         return '/photos/election/' + (candidate.electid || this.resultElectId) + '/' + value
      },

      formatDisplayDate(value) {
         if (!value) return '-'
         const date = new Date(value)
         if (isNaN(date.getTime())) return value
         return this.$moment(date).format('DD/MM/YYYY h:mm A')
      },

      toDatetimeLocal(value) {
         if (!value) return ''
         const date = new Date(value)
         if (isNaN(date.getTime())) return ''
         const pad = (num) => String(num).padStart(2, '0')
         return [
            date.getFullYear(),
            pad(date.getMonth() + 1),
            pad(date.getDate()),
         ].join('-') + 'T' + [pad(date.getHours()), pad(date.getMinutes())].join(':')
      },

      statusLabel(value) {
         if (value === '01') return 'Enabled'
         if (value === '02') return 'Suspended'
         return 'Disabled'
      },

      statusColor(value) {
         if (value === '01') return 'green'
         if (value === '02') return 'orange'
         return 'grey'
      },

      errorMessage(error, fallback) {
         const data = error && error.response && error.response.data
         if (data && data.message) return data.message
         if (data && data.error) return data.error
         return fallback
      },
   },
}
</script>

<style scoped>
.election-dialog {
   border-radius: 12px;
}

.election-dialog-body {
   background: #f6f8fb;
}

.election-form-section {
   border-radius: 12px;
   padding: 18px;
   height: 100%;
   background: #fff;
}

.election-section-title {
   display: flex;
   align-items: center;
   margin-bottom: 16px;
}

.timeline-card {
   border-radius: 10px;
   padding: 14px;
   height: 100%;
}

.election-form-actions {
   position: sticky;
   bottom: -16px;
   z-index: 2;
   margin: 18px -16px -16px;
   padding: 14px 16px;
   background: rgba(255, 255, 255, 0.96);
   border-top: 1px solid #e5e7eb;
   backdrop-filter: blur(4px);
}
</style>
